import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TooltipWrapper = (props) => {
    const { tooltip, tooltipClass } = props;
    const defaultTooltip = 'tooltip rounded shadow-lg py-2 px-3 bg-slate-600 text-white my-3 text-sm font-sans font-semibold';
    return (_jsxs("div", { className: "has-tooltip relative whitespace-nowrap", children: [props.children, tooltip && (_jsx("span", { className: tooltipClass ? tooltipClass : defaultTooltip, children: tooltip }))] }));
};
export default TooltipWrapper;
